var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-container"},[_c('div',{staticClass:"filter-box"},[_c('filters',{attrs:{"data":_vm.filterData,"total":_vm.total},on:{"on-search":_vm.onFilter}})],1),_c('video-list',{attrs:{"items":_vm.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }